/*
We are using the module.exports pattern to cut down on the boilerplate of
writing separate lines for import and export
*/

// $FlowFixMe - Flow doesn't like when `require` is passed anything besides a string literal
const asset = (name) => require(`./${name}`).default;

/* when you add a component to this list, also add it to index.js.flow */
const Icons = {
  ActivityIcon: asset('activity'),
  AddCandidateIcon: asset('add_candidate'),
  AddIcon: asset('add'),
  AnonymousIcon: asset('anonymous'),
  Arrow: asset('arrow'),
  ArrowLink: asset('arrow_link'),
  BackArrow: asset('back_arrow'),
  Calendar: asset('calendar'),
  Checkmark: asset('checkmark'),
  CheckMarkCircle: asset('checkmark_circle'),
  CircleSkipIcon: asset('circle_skip'),
  CircleXIcon: asset('circle_x'),
  ContactsIcon: asset('contacts'),
  Dashboard: asset('dashboard'),
  DataIcon: asset('data'),
  DataTable: asset('data_table'),
  DownArrow: asset('down_arrow'),
  DownloadIcon: asset('download'),
  Ellipsis: asset('ellipsis'),
  EmailIcon: asset('email'),
  ErrorIcon: asset('error'),
  ExclamationIcon: asset('exclamation'),
  FormIcon: asset('form'),
  PaperclipIcon: asset('paperclip'),
  FileIcon: asset('file'),
  Filter: asset('filter'),
  ForwardArrow: asset('forward_arrow'),
  GearIcon: asset('gear'),
  Globe: asset('globe'),
  GreenhouseLogo: asset('greenhouse_logo'),
  GreenhouseLogoTwo: asset('greenhouse_logo_two'),
  GreenhouseLogoWhiteSquare: asset('greenhouse_logo_white_square'),
  GridIcon: asset('grid'),
  GrippyIcon: asset('grippy'),
  HeadsUpIcon: asset('heads_up'),
  InformationIcon: asset('information'),
  JobIcon: asset('job'),
  LightBulbIcon: asset('lightbulb'),
  LightningIcon: asset('lightning'),
  LinkIcon: asset('link'),
  LinkedInIcon: asset('linkedin'),
  LocationIcon: asset('location'),
  LockIcon: asset('lock'),
  MinimizeIcon: asset('minimize'),
  MoveIcon: asset('move'),
  NeutralIcon: asset('neutral'),
  NoteIcon: asset('note'),
  OnTrackIcon: asset('on_track'),
  PDFIcon: asset('pdf'),
  PencilIcon: asset('pencil'),
  PendingIcon: asset('pending'),
  PlayIcon: asset('play'),
  PlusIcon: asset('plus'),
  PreviewIcon: asset('preview'),
  PrivateEyeIcon: asset('private_eye'),
  RatingMixedIcon: asset('rating_mixed'),
  RatingNoIcon: asset('rating_no'),
  RatingNoDecisionIcon: asset('rating_no_decision'),
  RatingYesIcon: asset('rating_yes'),
  RatingStrongNoIcon: asset('rating_strong_no'),
  RatingStrongYesIcon: asset('rating_strong_yes'),
  RecordIcon: asset('record'),
  RejectIcon: asset('reject'),
  ReportIcon: asset('report'),
  ReportBarGraphIcon: asset('report_bar_graph'),
  ReportFunnelIcon: asset('report_funnel'),
  RetriggerIcon: asset('retrigger'),
  ReminderIcon: asset('reminder'),
  Rocket: asset('rocket'),
  SearchIcon: asset('search'),
  ScorecardIcon: asset('scorecard'),
  StopIcon: asset('stop'),
  TestIcon: asset('test'),
  TouchpointIcon: asset('touchpoint'),
  TrashCanIcon: asset('trash_can'),
  UpArrow: asset('up_arrow'),
  UploadIcon: asset('upload'),
  User: asset('user'),
  VideoIcon: asset('video'),
  XIcon: asset('xicon'),
};

module.exports = Icons;
